import { render, staticRenderFns } from "./PlayerGalacticCycleCompleteEvent.vue?vue&type=template&id=40cae5be&scoped=true&"
import script from "./PlayerGalacticCycleCompleteEvent.vue?vue&type=script&lang=js&"
export * from "./PlayerGalacticCycleCompleteEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cae5be",
  null
  
)

export default component.exports